(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sw-media-dashes')) {
  class SwMediaDashes extends HTMLElement {
    connectedCallback() {
      if (this._onScroll) return;

      this.gallery = this.closest('slider-component');
      this.slider = this.gallery?.querySelector('.product__media-list');
      this.dashes = Array.from(
        this.querySelectorAll('.sw-media-dashes__item')
      );

      if (!this.gallery || !this.slider || !this.dashes.length) {
        return;
      }

      this.slides = Array.from(
        this.slider.querySelectorAll('.product__media-item')
      );

      this.slideCenters = [];
      this._rafId = null;

      this._onScroll = () => {
        if (this._rafId !== null) return;

        this._rafId = requestAnimationFrame(() => {
          this._rafId = null;
          this.updateActiveDash();
        });
      };

      this._onResize = () => {
        if (this._rafId !== null) {
          cancelAnimationFrame(this._rafId);
        }

        this._rafId = requestAnimationFrame(() => {
          this._rafId = null;

          this.cacheSlidePositions();
          this.positionDashes();
          this.updateActiveDash();
        });
      };

      this.slider.addEventListener(
        'scroll',
        this._onScroll,
        { passive: true }
      );

      window.addEventListener(
        'resize',
        this._onResize,
        { passive: true }
      );

      this.cacheSlidePositions();
      this.positionDashes();
      this.updateActiveDash();

      this.classList.add('is-ready');
    }

    disconnectedCallback() {
      if (this.slider && this._onScroll) {
        this.slider.removeEventListener(
          'scroll',
          this._onScroll
        );
      }

      if (this._onResize) {
        window.removeEventListener(
          'resize',
          this._onResize
        );
      }

      if (this._rafId !== null) {
        cancelAnimationFrame(this._rafId);
      }

      this._rafId = null;
      this._onScroll = null;
      this._onResize = null;

      this.gallery = null;
      this.slider = null;
      this.slides = null;
      this.dashes = null;
      this.slideCenters = null;
    }

    cacheSlidePositions() {
      if (!this.slides?.length) return;

      this.slideCenters = this.slides.map((slide) => {
        return slide.offsetLeft + slide.offsetWidth / 2;
      });
    }

    updateActiveDash() {
      if (
        !this.slider ||
        !this.slideCenters?.length ||
        !window.matchMedia('(max-width: 749px)').matches
      ) {
        return;
      }

      const visibleCenter =
        this.slider.scrollLeft +
        this.slider.clientWidth / 2;

      let activeIndex = 0;
      let smallestDistance = Infinity;

      this.slideCenters.forEach((center, index) => {
        const distance = Math.abs(center - visibleCenter);

        if (distance < smallestDistance) {
          smallestDistance = distance;
          activeIndex = index;
        }
      });

      this.dashes.forEach((dash, index) => {
        dash.classList.toggle(
          'is-active',
          index === activeIndex
        );
      });
    }

    positionDashes() {
      if (
        !this.gallery ||
        !this.slides?.length ||
        !window.matchMedia('(max-width: 749px)').matches
      ) {
        return;
      }

      const referenceSlide = this.slides[0];

      const mediaBox =
        referenceSlide.querySelector('.global-media-settings') ||
        referenceSlide;

      const mediaRect = mediaBox.getBoundingClientRect();
      const galleryRect = this.gallery.getBoundingClientRect();

      const left =
        mediaRect.left -
        galleryRect.left +
        mediaRect.width / 2;

      const top =
        mediaRect.bottom -
        galleryRect.top -
        14;

      this.style.left = `${left}px`;
      this.style.top = `${top}px`;
    }
  }

  customElements.define(
    'sw-media-dashes',
    SwMediaDashes
  );
}
  } catch(e) { console.error(e); }
})();

})();
